import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { mockBrokers } from '../../services/mockData';

const BrokersListPage = () => {
  const [brokers, setBrokers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setBrokers(mockBrokers);
      setLoading(false);
    }, 500);
  }, []);

  const handleToggleStatus = (brokerId) => {
    setBrokers(brokers.map(b => 
      b.id === brokerId 
        ? { ...b, status: b.status === 'Active' ? 'Disabled' : 'Active' }
        : b
    ));
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="page-header d-print-none">
      <div className="row g-2 align-items-center mb-3">
        <div className="col">
          <h2 className="page-title">Broker Companies</h2>
          <div className="text-secondary mt-1">Manage broker relationships</div>
        </div>
        <div className="col-auto ms-auto">
          <button className="btn btn-primary">
            <i className="ti ti-plus me-2"></i>
            Add Broker Company
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-vcenter">
              <thead>
                <tr>
                  <th>Broker Name</th>
                  <th>Main Office NMLS</th>
                  <th>Status</th>
                  <th>Created Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {brokers.map((broker) => (
                  <tr key={broker.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-2">
                          {broker.name.charAt(0)}
                        </div>
                        <div>
                          <div className="fw-bold">{broker.name}</div>
                          <div className="text-secondary small">{broker.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="badge bg-blue-lt">{broker.mainOfficeNmls}</span>
                    </td>
                    <td>
                      <span className={`badge ${broker.status === 'Active' ? 'bg-green-lt' : 'bg-red-lt'}`}>
                        {broker.status}
                      </span>
                    </td>
                    <td>{new Date(broker.createdDate).toLocaleDateString()}</td>
                    <td>
                      <div className="btn-group">
                        <Link to={`/lender/brokers/${broker.id}`} className="btn btn-sm btn-ghost-primary">
                          <i className="ti ti-eye"></i>
                        </Link>
                        <button 
                          className="btn btn-sm btn-ghost-secondary"
                          onClick={() => handleToggleStatus(broker.id)}
                        >
                          <i className={`ti ti-${broker.status === 'Active' ? 'ban' : 'check'}`}></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokersListPage;
